const theme = {
    primary: "#AD3EDB",
    secondary: "#EC3EA2",
    text: "#FFF",
    bg: "#1B1B1B",
    accentBg: "#121212"
};

export default theme